/* eslint-disable react/jsx-filename-extension, import/no-dynamic-require, global-require */
import React from "react";
import { Provider } from "react-redux";
import ReactDOM from "react-dom";
// import createHistory from "history/createBrowserHistory";
import { ConnectedRouter } from "react-router-redux";
import { addLocaleData, IntlProvider } from "react-intl";
import Cookie from "js-cookie";
import App from "./components/App";
import configureStore from "./utils/configureStore";
import allLangs from "./lang/assets/lang-dict";
import { createBrowserHistory } from "history";
import {
  initAnalytics,
  setUser,
  setUserInfo,
  enableMirroring,
  optOut,
} from "./telemetry/analytics";
import { AMPLITUDE_MIRROR_INSTANCE_NAME } from "./telemetry/constants";
import * as footer from "./constants/footerData";
import { proxyTargets } from "./constants/appData";

const getLangAsset = async (langFunc) => {
  const asset = await langFunc();
  return asset;
};

const logUserData = (state) => {
  const {
    userDetails: { profileInfo, puaId, trafficSource },
    productInfo: { interfaceId },
  } = state;

  setUser(puaId || null);
  setUserInfo({
    group_id: profileInfo.groupId,
    cust_id: profileInfo.custId,
    customer_ID: profileInfo.custId,
    profile_id: profileInfo.profileId,
    interface_id: interfaceId,
    auth_method_primary: trafficSource.authMethodPrimary,
    auth_method_secondary: trafficSource.authMethodSecondary,
    ehr_vendor: trafficSource.ehrVendor,
    ehr_location: trafficSource.ehrLocation,
  });
};

function render(locale, messages) {
  // Get initial state from server-side rendering
  // eslint-disable-next-line no-underscore-dangle, no-undef

  if (process.env.NODE_ENV === "development") {
    const productCode = process.env.REACT_APP_PRODUCT_CODE;
    // set initial state for localhost development
    window.__INITIAL_STATE__ = {
      paths: {
        baseUrl: "",
        api: `${proxyTargets[productCode]}/api/storefront`,
      },
      productInfo: {
        productCode,
        interfaceId: productCode,
        footer: footer[productCode] || footer.defaultFooter,
      },
      userDetails: {
        userState: {
          organizational: false,
          personalized: true,
        },
        profileInfo: {
          groupId: "main",
          custId: "awsbasic",
          profileId: "dmp",
        },
        puaId: "8237765",
        trafficSource: {},
      },
      amplitude: {
        ampId: "fac98eccc7a53477d47706b655369445",
        apiDomain: "staging-telemetry.ebsco.com",
      },
    };
  }

  const initialState = window.__INITIAL_STATE__;

  // const history = createHistory();
  const history = createBrowserHistory({
    basename: process.env.PUBLIC_URL,
  });
  const store = configureStore(history, initialState);
  const state = store.getState();

  const { amplitude } = state;
  if (amplitude?.ampId) {
    const opts = {
      includeReferrer: true,
      unsetParamsReferrerOnNewSession: true,
      includeUtm: true,
      ...(amplitude?.apiDomain && {
        apiEndpoint: `${amplitude.apiDomain}`,
      }),
    };

    initAnalytics(amplitude.ampId, opts);

    //Initialize duplicate analytics and enable to compare to BI-enabled performance. This a temporary experiment
    if (amplitude?.mirrorAmpId) {
      initAnalytics(
        amplitude.mirrorAmpId,
        {
          includeReferrer: true,
          unsetParamsReferrerOnNewSession: true,
        },
        AMPLITUDE_MIRROR_INSTANCE_NAME
      );
      enableMirroring(true);
    }
  }

  if (window.Osano) {
    window.Osano.cm.addEventListener(
      "osano-cm-consent-saved",
      (consentObject) => {
        if (consentObject.ANALYTICS === "ACCEPT") {
          optOut(false);
          logUserData(state);
        } else {
          optOut(true);
        }
      }
    );
  }

  ReactDOM.render(
    <Provider store={store}>
      <IntlProvider locale={locale} messages={messages}>
        <ConnectedRouter history={history}>
          <App />
        </ConnectedRouter>
      </IntlProvider>
    </Provider>,
    // eslint-disable-next-line no-undef
    document.getElementById("root")
  );
  // Uncomment this when you are done developing your app..
  // registerServiceWorker();
}

let locale = Cookie.get("locale") || "en";
try {
  const localeData = require(`react-intl/locale-data/${locale}`);
  addLocaleData(localeData);
  // Fallback to en if an error -> asset not there
  getLangAsset(allLangs[locale] || allLangs.en).then((messages) => {
    render(locale, messages);
  });
} catch (e) {
  locale = "en";
  // Fall back to english file that isnt auto generated by yarn intl..
  const messages = require("./lang/en.json");
  addLocaleData(require("react-intl/locale-data/en"));
  render(locale, messages);
}
